<template>


  <div class="content-wrap">

    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            
            <ElLabel name="기간">
              <template #end>
                <ElLabel name="월별 :" classNm="text-nowrap pe-2">
                  <template #end="{id}">
                    <ElSelect :id="id" v-model="selectMonth.selectVal" :options="selectMonth.options" @selectClick=""/>
                  </template>
                </ElLabel>
              </template>
            </ElLabel>
          </div>
        </div>
        
                              
      </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="clickOpenDialog({key:'confirm' , target: state.inoutSelectedRow,title :`총 ${state.inoutSelectedRow.length}건을 변경하고자하는 날짜를 선택해주세요.`})">일괄 변경</ElButton>
      <ElButton type="search" @buttonClick="shareToUser()">공유하기</ElButton>
      <ElButton type="search" @buttonClick="searchPayment()">검색</ElButton>
    </div>

    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <h4 class="title-sm mb-0">실시간/당해년도</h4>
      </div>
      
      <div class="table-btn-group d-flex align-items-center">
        <!-- <ElButton type="share" @buttonClick="shareToUser"></ElButton> -->
        <ElButton type="excelDownload" @buttonClick="excelDown()">
          엑셀다운
        </ElButton>
        <img src="/images/vr.png" alt="" />
        <span class="rd-won">(단위:원)</span>
      </div>
  
    </div>         
    
    <div class="table-responsive table-list table-pm">
      <DataTable  
          :value="gridOption.value"   
          editMode="cell" 
          @cell-edit-complete="onCellEditComplete"
          resizableColumns 
          scrollable
          scrollHeight="650px"
          columnResizeMode=""
          paginator 
          :rows="20" 
          :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
      > <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
      <Column>
                    <template #header>
                      <ElCheckbox v-model="allCheck"/>
                    </template>
                    <template #body="{ data }">
                        <ElCheckbox 
                        v-model="state.inoutSelectedRow" 
                        :value="data"
                        />
                    </template>
                  </Column>
      <Column 
        v-for="(col,index) of gridOption.columnList" 
        :key="index" 
        :field="col.field" 
        :header="col.header" 
        :style="[col.field === 'note' ? 'min-width:150px;' : col.style]"
      >
        <template  #body="{ data, field }" >
          <template v-if="field === 'agreeNo' || field === 'note'" >
              <div class="col_summary">{{ data[field] || '(수기입력)' }}</div>
          </template>

          <template v-else-if="field === 'vatplus' || field === 'vatminus' || field === 'taxamt'">
              <div class="col_summary" style="text-align: right;">
                <span :class="isNegative(data[field])">{{ numberFomat(data[field]) }}</span>
              </div>
          </template>

          <template v-else-if="field === 'reg_id' || field.includes('_yn')">
              <div class="col_summary" style="text-align: center;">{{ data[field] }}</div>
          </template>

          <template v-else>
            <div class="col_summary">{{ data[field] }}</div>
          </template>
        </template>


        <template #editor="{ data, field }">
          <template v-if="field === 'agreeNo' || field === 'note'" >
                <ElInput v-model="data[field]" autofocus />
          </template>

          <template v-else-if="field === 'vatplus' || field === 'vatminus' || field === 'taxamt'">
              <div class="col_summary" style="text-align: right;">
                <span :class="isNegative(data[field])">{{ numberFomat(data[field]) }}</span>
              </div>
          </template>
          
          <template v-else-if="field === 'reg_id' || field.includes('_yn')">
              <div class="col_summary" style="text-align: center;">{{ data[field] }}</div>
          </template>

          <template v-else>
            <div class="col_summary">{{ data[field] }}</div>
          </template>
        </template>

        
      </Column>
      <ColumnGroup type="footer">
          <Row>
              <Column footer="합계" :colspan="3" footerStyle="text-align:center" />

              <Column :footer="total.vatplus" footerStyle="text-align:right"/>
              <Column :footer="total.vatminus" footerStyle="text-align:right"/>
              <Column :footer="total.taxamt" footerStyle="text-align:right"/>
              <Column :colspan="7"/>
          </Row>
      </ColumnGroup>
      
      </DataTable>
      
    </div>

  </div>
  <dateModal ref="dateModalRef"
       @updateValue="handleUpdateValue"
       @updateIndex="handleUpdateIndex"
    />
  <!-- 메일발송 모달 (1.컴포넌트) -->
  <EmailSendModal ref="emailSendModalRef" />
  <!-- 엑셀 유틸 컴포넌트 -->
  <excelUtil ref="excelUtilRef" v-show="false" />
  
</template>
    
<script setup>   
import {ref,onBeforeMount,reactive,computed} from 'vue'
import { getPaymentList,getPaymentListUpdate } from '@/api/monthly';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from "primevue/columngroup"
import Row from "primevue/row"
import common from '@/js/common';
import excelUtil from "@/components/common/MCO_EX_001.vue";
import EmailSendModal from "@/components/common/modal/EmailSendModal.vue";
import { useUserStore } from "@/store/user";
import dateModal from '@/components/common/modal/dateModal.vue'
import { useLoading } from "@/composable/Loading.js";
const { setIsLoading } = useLoading();
const userStore = useUserStore()
const excelUtilRef = ref();
const emailSendModalRef = ref();
const dateModalRef = ref()

onBeforeMount(async()=>{
  await searchPayment()
})


const selectMonth = ref({
  selectVal : getThisMonth(),
  options: [
      {text : '1월' , value : '01'},
      {text : '2월' , value : '02'},
      {text : '3월' , value : '03'},
      {text : '4월' , value : '04'},
      {text : '5월' , value : '05'},
      {text : '6월' , value : '06'},
      {text : '7월' , value : '07'},
      {text : '8월' , value : '08'},
      {text : '9월' , value : '09'},
      {text : '10월' , value : '10'},
      {text : '11월' , value : '11'},
      {text : '12월' , value : '12'},
    ]
  }
)

const state =reactive({
  inoutSelectedRow:[],
  selectDate : null
})


const allCheck = computed({
    get(){
      return [...gridOption.value.value].length === state.inoutSelectedRow.length;
    },
    set(newValue){
      let contentList = [...gridOption.value.value]
      state.inoutSelectedRow = newValue ? contentList.map((item)=>{return item}) : [];
    }
})
const total = ref({
  tax_sale_dt : '합계',
  vatplus : 0,
  vatminus :0,
  taxamt : 0,
})

const gridOption = ref({
  value : [],
  columnList : [
    { header: '매입계산서발행일자',       field: "tax_sale_dt"},
    { header: '매입처',         field: "buy_cmp_info_nm"},
    { header: '총 지급액(VAT포함)',         field: "vatplus"},
    { header: '매입금액',         field: "vatminus" ,footer:true,style:{textAlign : 'right'}},
    { header: '부가세',   field: "taxamt" ,footer:true,style:{textAlign : 'right'}},
    { header: '영업기회 ID',      field: "sales_id"},
    { header: '영업기회명',       field: "sales_nm"},

    { header: '영업대표',       field: "usr_nm",style:{textAlign : 'center'}},
    { header: '매출계산서 발행여부',       field: "tax_yn"},
    { header: '매출 수금여부',       field: "collect_yn"},
    { header: '매입계산서 발행여부',       field: "tax_sale_yn"},
    { header: '비고',       field: "note"},
  ],

})
const clickOpenDialog = (value) =>{
  const {key,target,title} = value
  if(target.length == 0){
    alert('선택된 행이 없습니다.')
  }else{
    dateModalRef.value.openDialog(key,target,title)
  }
}

const updateSalesList = async() =>{
    let successCnt = 0
    try {
      setIsLoading(true)
      for (let param of state.inoutSelectedRow) {
        param = {
          opty_inout_seq : param.opty_inout_seq,
          selectDate: state.selectDate,  
        }
        const res = await getPaymentListUpdate(param)
        successCnt+=1
      }
    } catch (err) {
      console.error(err)
      // alert(`회사관리번호 ${param.opty_inout_seq} 의 수정을 실패했습니다.`)
    } finally {
      setIsLoading(false)

      alert(`총 ${state.inoutSelectedRow.length}중에 ${successCnt} 수정했습니다.`)
      await searchPayment()
    }
}

const handleUpdateValue = async(value) =>{
  state.selectDate = value
  await updateSalesList();
}


async function searchPayment(){
  gridOption.value.value = []
  total.value.tax_sale_dt =  '합계'
  total.value.vatplus =  0
  total.value.vatminus =  0
  total.value.taxamt =  0
  
  let fs_yearMM = `${new Date().getFullYear() + selectMonth.value.selectVal}`
  let params = {
    fs_yearMM : fs_yearMM,
    employee_id :  userStore.user.employeeId
  }
  //임원,관리자는 전체 검색
   if(['ADMIN', 'E'].includes(userStore.user.authGrpId)) params.employee_id = ''
  const res = await getPaymentList(params)

  
  gridOption.value.value = [...res.rtn]
  let totalObj = {
    tax_sale_dt : '합계',
    vatplus : 0,
    vatminus : 0,
    taxamt : 0
  }

  //footer 합계부분 
  res.rtn.forEach((item)=>{
    totalObj.vatplus += isNaN(item.vatplus) ?  0 : Number(item.vatplus)
    
    totalObj.vatminus += isNaN(item.vatminus) ?  0 : Number(item.vatminus)
    totalObj.taxamt += isNaN(item.taxamt) ?  0 : Number(item.taxamt)
  })

  totalObj.vatplus = numberFomat( Math.round(totalObj.vatplus * 100) /100 )
  totalObj.vatminus = numberFomat( Math.round(totalObj.vatminus * 100) /100 )
  totalObj.taxamt = numberFomat( Math.round(totalObj.taxamt * 100) /100 )
  total.value =  totalObj
  state.inoutSelectedRow =[];
}

function numberFomat(num){
  //payment는 원단위임으로 소수점 노출 x
  num = isNaN(num) ? '0' :Number(num).toFixed(0)
  return common.checkNumberComma(num)
}

function onCellEditComplete(event){
  let { data, newValue, field } = event;
  data[field] = newValue
}

//공유하기
function shareToUser(){
  openEmailSend();
}

/** 메일발송 모달 (3.팝업오픈) */
function openEmailSend(){
  //메일정보 초기값
  const emailParams = {
    call_prgm_id: 'MRD_RT_005',
    call_prgm_nm: 'Payment',
    receiver_ids: '',
    receiver_nms: '',
    title: 'Payment 정보 공유드립니다.',
    content: makeEmailContent()
  };

  emailSendModalRef.value.openEmailModal(emailParams);
};


/** 메일발송 모달 (4.메일내용) */
function makeEmailContent() {
  //선택된 상품 분류체계 목록
  let contentList = [...gridOption.value.value]
 
  //메일 내용 만들기
  let contentStr = '';
  for (let [index, content] of contentList.entries()) {
    let innerStr = `${index+1}.<b>영업기회 ID</b>: ${content.sales_id || ''}<br>` 
                  +`<b>매입계산서발행일자 </b>: ${content.tax_sale_dt || ''}<br>`
                  +`<b>매입처</b>: ${content.buy_cmp_info_nm || ''}<br>`
                  +`<b>총 지급액(+VAT)</b>: ${numberFomat(content.vatplus) || ''}<br>` 
                  +`<b>매입금액(-VAT)</b>: ${numberFomat(content.vatminus) || ''}<br>`
                  +`<b>부가세</b>: ${numberFomat(content.taxamt) || ''}<br>`  
                  +`<b>영업기회명</b>: ${content.sales_nm || ''}<br>`
                  +`<b>영업대표</b>: ${content.usr_nm || ''}<br>`
                  +`<b>매출계산서 발행여부</b>: ${content.tax_yn || ''}<br>`
                  +`<b>매출 수금여부</b>: ${content.collect_yn || ''}<br>`
                  +`<b>매입계산서 발행여부</b>: ${content.tax_sale_yn || ''}<br>`
                  +`<b>비고</b>: ${content.note || ''}<br><br>`
                  +`===================================================<br><br>`;

    contentStr += innerStr
  }

  return contentStr;
}

//엑셀 다운로드
function excelDown(){
  let fileNm = "Payment";
  let header =  [
    { header: '매입계산서발행일자',       field: "tax_sale_dt" },
    { header: '매입처',         field: "buy_cmp_info_nm"},
    { header: '총 지급액(VAT포함)',         field: "vatplus" },
    { header: '매입금액',         field: "vatminus"},
    { header: '부가세',   field: "taxamt" },
    { header: '영업기회 ID',      field: "sales_id"},
    { header: '영업기회명',       field: "sales_nm"},

    { header: '영업대표',       field: "usr_nm"},
    { header: '매출계산서 발행여부',       field: "tax_yn"},
    { header: '매출 수금여부',       field: "collect_yn"},
    { header: '매입계산서 발행여부',       field: "tax_sale_yn"},
    { header: '비고',       field: "note"},
  ]
  
  let dataList = [...gridOption.value.value,{...total.value}].map((item)=>{
    item['vatplus'] = typeof item['vatplus'] === 'string' ? item['vatplus'].replaceAll(',','') : item['vatplus']
    item['vatminus'] = typeof item['vatminus'] === 'string' ? item['vatminus'].replaceAll(',','') : item['vatminus']
    item['taxamt'] = typeof item['taxamt'] === 'string' ? item['taxamt'].replaceAll(',',''): item['taxamt']

    item['vatplus'] = isNaN(Number(item['vatplus'])) ? item['vatplus'] : Number(item['vatplus']).toFixed(0)
    item['vatminus'] = isNaN(Number(item['vatminus'])) ? item['vatminus'] : Number(item['vatminus']).toFixed(0)
    item['taxamt'] = isNaN(Number(item['taxamt'])) ? item['taxamt'] : Number(item['taxamt']).toFixed(0)
    return item
  })
  excelUtilRef.value.excelDownload(fileNm, header, dataList);

};



function getThisMonth() {
  return (new Date().getMonth()+1).toString().padStart(2, '0')
}

function isNegative(data){
  if(!data) return
  data = data.toString().replaceAll('%','')

  if(Number(data) < 0){
    return 'text-b-rt'
  }
}
</script>
      